/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { AuthorableComponent } from '@core/aem/models/authorable-component.model';
import { HorizontalRuleData } from './models/horizontal-rule-data.interface';

/**
 * @deprecated Don't use Patrick is using this to omit some AEM fields
 */
@Component({
  selector: 'tmo-horizontal-rule',
  templateUrl: './horizontal-rule.component.html',
  styleUrls: ['./horizontal-rule.component.scss'],
})
export class HorizontalRuleComponent
  extends AuthorableComponent<HorizontalRuleData>
  implements OnInit, OnDestroy
{
  @Input() public css: string;

  constructor() {
    super();
  }

  public ngOnInit(): void {}

  /**
   * Sets the data for the specified component. This is required as the AEM module will use this method to populate
   * component data
   * @param data Input data for AEM component
   */
  public setData(data: HorizontalRuleData): void {
    this.css = data.css;
  }

  public ngOnDestroy(): void {}
}
